if (!customElements.get('restock-alert')) {
  customElements.define(
    'restock-alert',
    class RestockAlert extends HTMLElement {
      connectedCallback() {
        this.tagsInput = this.querySelector('[data-restock-tags]');
        this.variantLabel = this.querySelector('[data-restock-variant-label]');
        this.editorPreview = this.dataset.editorPreview === 'true';

        this.update({
          id: this.dataset.variantId,
          title: this.dataset.variantTitle,
          available: this.dataset.available === 'true',
        });

        if (
          typeof subscribe === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined' &&
          PUB_SUB_EVENTS.variantChange
        ) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (String(data.sectionId) !== String(this.dataset.sectionId)) return;
            this.update(data.variant);
          });
        }
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      update(variant) {
        const validVariant = variant?.id;
        const shouldShow = this.editorPreview || (validVariant && variant.available === false);
        this.hidden = !shouldShow;

        if (!validVariant) return;
        this.dataset.variantId = variant.id;
        this.dataset.variantTitle = variant.title || '';
        this.dataset.available = String(variant.available);

        if (this.tagsInput) {
          this.tagsInput.value = `restock-alert,${this.dataset.productHandle},variant-${variant.id}`;
        }
        if (this.variantLabel) {
          this.variantLabel.textContent = variant.title && variant.title !== 'Default Title' ? variant.title : '';
        }
      }
    }
  );
}
